<template>
    <div>
        <card-header title="Edit Classic Enrollment" icon="fa-pencil" />

        <card-toolbar>
            <b-button type="is-primary is-outlined" size="is-small" @click="resetEnrollment"><i
                    class="fas fa-history mr-2"></i>Reset Enrollment</b-button>
        </card-toolbar>

        <card-body>
            <classic-enrollment-form :enrollment="enrollment" v-if="enrollment" @loading="loading" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column is-1">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteEnrollment"><i
                            class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete
                            Enrollment?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" class="mr-3"
                        :disabled="!enrollment || !enrollment.configSelect" @click="submit"><i
                            class="fas fa-check mr-2"></i>Save Enrollment
                    </b-button>
                </div>
            </div>
        </card-footer>

        <card-footer class="has-text-right">
            <span class="is-clickable" @click="$copyText(enrollment.id)"><i class="fal fa-barcode-alt mr-2"></i>{{
                enrollment.id }}</span>
        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardToolbar from "@/TIER/components/CardToolbar";
import CardFooter from "@/TIER/components/CardFooter";
import QuoteForm from "@/cards/reseller/QuoteForm";

import { client as http } from '../../http_client';

import async from 'async';
import { mapGetters } from "vuex";
import ClassicEnrollmentForm from "./ClassicEnrollmentForm";
import moment from 'moment';

export default {
    components: { ClassicEnrollmentForm, QuoteForm, CardFooter, CardToolbar, CardBody, CardHeader },
    props: ['card', 'props'],
    data() {
        return {
            enrollment: null,
            confirmDelete: false,
            dirty: null,
            loaded: false
        };
    },
    methods: {
        load: function () {
            this.$emit('loading', true);

            async.parallel([
                (cb) => {
                    http.get('courses').then(response => {
                        this.courses = response.data;
                        cb();
                    });
                },
                (cb) => {
                    http.get('enrollments/c/' + this.props.enrollId, { force: true }).then(response => {
                        response.data.enrollDate = (response.data.enrollDate && response.data.enrollDate !== '0000-00-00 00:00:00') ? moment(response.data.enrollDate).toDate() : null;
                        response.data.startedDate = (response.data.startedDate && response.data.startedDate !== '0000-00-00 00:00:00') ? moment(response.data.startedDate).toDate() : null;
                        response.data.completedDate = (response.data.completedDate && response.data.completedDate !== '0000-00-00 00:00:00') ? moment(response.data.completedDate).toDate() : null;
                        response.data.verifyDate = (response.data.verifyDate && response.data.verifyDate !== '0000-00-00 00:00:00') ? moment(response.data.verifyDate).toDate() : null;
                        response.data.expires_on = (response.data.expires_on) ? moment(response.data.expires_on).toDate() : null;

                        this.enrollment = { courseSelect: null, configSelect: null, ...response.data };
                        cb();
                    }).catch(err => {
                        console.log(err);
                        cb(err);
                    });
                }
            ], err => {
                if (err) console.log(err);
                this.$emit('loading', false);
                this.loaded = true;
            });
        },
        submit: function () {
            let payload = {
                configID: this.enrollment.configSelect.id,
                // certificationID: null,
                planID: this.enrollment.planID,
                provider: this.enrollment.configSelect.provider,
                units: this.enrollment.units,
                // unittype: null,
                customName: (this.enrollment.customName) ? this.enrollment.customName.trim() : null,
                disabled: this.enrollment.disabled,
                disabletext: this.enrollment.disabletext,
                enrollDate: (this.enrollment.enrollDate) ? moment(this.enrollment.enrollDate).format('YYYY-MM-DD HH:mm:ss') : null,
                startedDate: (this.enrollment.startedDate) ? moment(this.enrollment.startedDate).format('YYYY-MM-DD HH:mm:ss') : null,
                completedDate: (this.enrollment.completedDate) ? moment(this.enrollment.completedDate).format('YYYY-MM-DD HH:mm:ss') : null,
                verifyDate: (this.enrollment.verifyDate) ? moment(this.enrollment.verifyDate).format('YYYY-MM-DD HH:mm:ss') : null,
                totalPaid: this.enrollment.totalPaid,
                completed: this.enrollment.completed,
                surveycompleted: this.enrollment.surveycompleted,
                readonly: this.enrollment.readonly,
                manualaward: this.enrollment.manualaward,
                stem: this.enrollment.stem,
                stem_units: this.enrollment.stem_units,
                other_units: this.enrollment.other_units,
                adminnotes: this.enrollment.adminnotes,
                expires_on: (this.enrollment.expires_on) ? moment(this.enrollment.expires_on).format('YYYY-MM-DD HH:mm:ss') : null,
            };

            if (this.enrollment.custom1 && this.enrollment.custom1 !== 'N/A') payload.customName += ' ' + this.enrollment.custom1.trim();
            if (this.enrollment.custom2 && this.enrollment.custom2 !== 'N/A') payload.customName += ' ' + this.enrollment.custom2.trim();

            this.$emit('loading', true);
            http.put('enrollments/c/' + this.props.enrollId, payload, { force: true }).then(response => {
                this.$reloadCard('course-enrollments');
                this.$reloadCard('user-details');
                this.$reloadCard('user');
                this.$saveAlert(false);
                this.$closeCard(this.card);
            }).catch(err => {

            });
        },
        resetEnrollment: function () {
            if (window.confirm('Are you sure you want to reset this enrollment? This will permanently erase all setup data, course data, and logged time.')) {
                this.$emit('loading', true);
                http.post('enrollments/c/' + this.props.enrollId + '/reset', { id: this.props.enrollId }).then(response => {
                    this.load();
                }).catch(err => {
                    this.$emit('loading', false);
                });
            }
        },
        deleteEnrollment() {
            if (this.confirmDelete) {
                this.$emit('loading', true);
                http.delete('enrollments/c/' + this.props.enrollId).then(response => {
                    this.$reloadCard('course-enrollments');
                    this.$reloadCard('user-details');
                    this.$reloadCard('user');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            } else {
                this.confirmDelete = true;
                setTimeout(() => {
                    this.confirmDelete = false;
                }, 3000);
            }
        },
        loading: function (val) {
            this.$emit('loading', val);
        }
    },
    watch: {
        'props.enrollId': function () {
            this.dirty = null;
            this.load();
        },
        'enrollment': {
            deep: true,
            handler: function () {
                if (!this.loaded) return;
                this.dirty = (this.dirty !== null);
                if (!this.$TIER.saveAlert.active && this.dirty)
                    this.$saveAlert(true, 'Are you done editing this enrollment? Unsaved changes will be lost.');
            }
        }
    },
    mounted() {
        this.load();
    }
};
</script>
